import { useState } from 'react';
import { Link2, Check } from 'lucide-react';

interface ShareButtonsProps {
  title: string;
  url: string;
}

export default function ShareButtons({ title, url }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);
  const fullUrl = `https://www.residualvault.com${url}`;
  const encoded = encodeURIComponent(fullUrl);
  const encodedTitle = encodeURIComponent(title);

  const copyLink = () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(fullUrl);
      } else {
        const el = document.createElement('textarea');
        el.value = fullUrl;
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="text-sky-blue text-sm font-medium">Share:</span>
      <a href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encoded}&via=ResidualVault`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-steel-blue/10 border border-sky-blue/20 rounded-lg text-sky-blue text-sm font-semibold hover:bg-black/20 transition-all">
        <span className="font-bold">X</span> Twitter
      </a>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-steel-blue/10 border border-sky-blue/20 rounded-lg text-sky-blue text-sm font-semibold hover:bg-blue-600/20 transition-all">
        <span className="font-bold">in</span> LinkedIn
      </a>
      <a href={`https://reddit.com/submit?url=${encoded}&title=${encodedTitle}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-steel-blue/10 border border-sky-blue/20 rounded-lg text-sky-blue text-sm font-semibold hover:bg-orange-500/20 transition-all">
        <span className="font-bold">r/</span> Reddit
      </a>
      <button onClick={copyLink} className="flex items-center gap-2 px-4 py-2 bg-steel-blue/10 border border-sky-blue/20 rounded-lg text-sky-blue text-sm font-semibold hover:bg-green-400/10 transition-all">
        {copied ? <Check className="w-4 h-4 text-green-400" /> : <Link2 className="w-4 h-4" />}
        {copied ? 'Copied!' : 'Copy Link'}
      </button>
    </div>
  );
}
